import { render, staticRenderFns } from "./UTTBalance.vue?vue&type=template&id=922f50d2&scoped=true&"
import script from "./UTTBalance.vue?vue&type=script&lang=js&"
export * from "./UTTBalance.vue?vue&type=script&lang=js&"
import style0 from "./UTTBalance.vue?vue&type=style&index=0&id=922f50d2&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "922f50d2",
  null
  
)

export default component.exports